// Simple events state manager
let listeners = [];
let isEventsExpanded = false;

export const setEventsExpanded = (expanded) => {
  isEventsExpanded = expanded;
  // Notify all listeners
  listeners.forEach(listener => listener(expanded));
};

export const getEventsExpanded = () => isEventsExpanded;

export const subscribeToEventsExpanded = (listener) => {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter(l => l !== listener);
  };
}; 